/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Task_Reminders_Create_ErrorInputs */

const en_task_reminders_create_error = /** @type {(inputs: Task_Reminders_Create_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to add reminder: ${i?.message}`)
};

const pt_br2_task_reminders_create_error = /** @type {(inputs: Task_Reminders_Create_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao adicionar lembrete: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Failed to add reminder: {message}" |
*
* @param {Task_Reminders_Create_ErrorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_reminders_create_error = /** @type {((inputs: Task_Reminders_Create_ErrorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Reminders_Create_ErrorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_reminders_create_error(inputs)
	return pt_br2_task_reminders_create_error(inputs)
});